/*
  2026-09-22 (agency-global, approved by Guneet: "the agency's code slows every page"):
  - Removed the ?tag= block. It fetched `${location.pathname}/${tag}` (a whole ~1 MB page,
    tag not encoded) and looked for a `.product-grid` our PLP does not have, so every ?tag=
    visit paid for a request whose answer was thrown away. newbrand-collection-priority does
    this job.
  - Removed the wrapper around window.fetch and XMLHttpRequest.open that fired `cart:updated`
    after every /cart/* request. Our side cart, cart page, wishlist and shop-the-look already
    fire `cart:refresh` after each cart write, and the dispatch-date saver
    (snippets/newbrand-dispatchsave.liquid) listens for it.
  - This file is no longer loaded on every page: snippets/scripts.liquid emits it only when the
    page has an agency `cat-grid-section` slider or a `<free-shipping-bar>`.
*/
(function () {
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.slider.cat-grid-section .cat-grid-wrapper');

  if (!slider) return;

  new Flickity(slider, {
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: false,
    imagesLoaded: true,
    draggable: true,
  });
});


const CART_EVENTS = ['cart:update', 'cart:refresh', 'cart:updated'];

 class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.settings = {
        threshold: Number(this.dataset.threshold) || 0,
        preText: this.dataset.preText,
        successText: this.dataset.successText
      };

      this.cacheDom();

      this.update = this.update.bind(this);

      this.update();

      // Nothing fires cart:updated for every cart request any more (the fetch/XHR wrapper is
      // gone), so listen to the events the cart code actually sends.
      CART_EVENTS.forEach((name) => document.addEventListener(name, this.update));
    }

    disconnectedCallback() {
      CART_EVENTS.forEach((name) => document.removeEventListener(name, this.update));
    }

    cacheDom() {
      this.track = this.querySelector('[data-fsb-track]');
      this.fill = this.querySelector('[data-fsb-fill]');
      this.message = this.querySelector('[data-fsb-message-text]');
      this.cartTotalEls = this.querySelectorAll('[data-fsb-cart-total]');
      this.thresholdLabelEls = this.querySelectorAll('[data-fsb-threshold-label]');
    }

    async update() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        this.render(cart.total_price);
      } catch (error) {
        console.error(error);
      }
    }

    render(cartTotal) {
      const remaining = this.settings.threshold - cartTotal;
      const complete = remaining <= 0;

      const progress =
        this.settings.threshold > 0
          ? Math.min(100, Math.max(0, (cartTotal / this.settings.threshold) * 100))
          : 100;

      this.fill.style.width = `${progress}%`;
      this.track?.setAttribute('aria-valuenow', Math.round(progress));
      this.classList.toggle('fsb--complete', complete);

      this.message.innerHTML = complete
        ? this.settings.successText
        : this.settings.preText.replace(
            '{{amount}}',
            `<strong>${this.formatMoney(remaining)}</strong>`
          );

      this.cartTotalEls.forEach((el) => {
        el.textContent = (el.dataset.message || '').replace(
          '{{amount}}',
          this.formatMoney(cartTotal)
        );
      });

      this.thresholdLabelEls.forEach((el) => {
        el.textContent = (el.dataset.message || '').replace(
          '{{amount}}',
          this.formatMoney(this.settings.threshold)
        );
      });
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney && window.theme_money_format) {
        return Shopify.formatMoney(cents, window.theme_money_format);
      }

      return `₹${Math.round(cents / 100).toLocaleString('en-IN')}`;
    }
  }

  if (!customElements.get('free-shipping-bar')) customElements.define('free-shipping-bar', FreeShippingBar);
})();
